import FigmaBlocksIcon from 'components/Icons/FigmaBlocksIcon';

interface Properties {
  width?: number;
  height?: number;
}

const BlocksIconActive = ({ width = 16, height = 16 }: Properties) => {
  return <FigmaBlocksIcon width={width} height={height} color='white' />;
};

export default BlocksIconActive;
